/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'profilency_meetings': {
    width: 19,
    height: 19,
    viewBox: '0 0 19 19',
    data: '<path pid="0" d="M14.094 3.762h2.725c.868 0 1.57.704 1.57 1.572V16.52a1.57 1.57 0 0 1-1.57 1.572H1.703A1.571 1.571 0 0 1 .13 16.52V5.334c0-.868.704-1.572 1.572-1.572h2.724v-2.49a.5.5 0 0 1 1 0v2.49h7.667v-2.49a.5.5 0 1 1 1 0v2.49zm0 1v1.804a.5.5 0 1 1-1 0V4.762H5.427v1.804a.5.5 0 1 1-1 0V4.762H1.703a.572.572 0 0 0-.572.572V16.52c0 .317.255.572.572.572h15.116a.57.57 0 0 0 .57-.572V5.334a.571.571 0 0 0-.57-.572h-2.725zM8.799 6.974a.5.5 0 0 1 .922 0l.987 2.358 2.547.21a.5.5 0 0 1 .285.877l-1.938 1.666.588 2.487a.5.5 0 0 1-.747.542L9.26 13.786l-2.183 1.328a.5.5 0 0 1-.746-.542l.588-2.487-1.938-1.666a.5.5 0 0 1 .285-.877l2.547-.21.986-2.358zm-.18 3.024a.5.5 0 0 1-.42.305l-1.66.137 1.262 1.085a.5.5 0 0 1 .16.494l-.382 1.62L9 12.773a.5.5 0 0 1 .52 0l1.421.864-.382-1.619a.5.5 0 0 1 .16-.494l1.262-1.085-1.658-.137a.5.5 0 0 1-.42-.305L9.26 8.463l-.642 1.535z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/profilency_meetings.js